import { render } from "./nestedFolders.vue?vue&type=template&id=6ffa85e9&scoped=true"
import script from "./nestedFolders.vue?vue&type=script&lang=js"
export * from "./nestedFolders.vue?vue&type=script&lang=js"

import "./nestedFolders.vue?vue&type=style&index=0&id=6ffa85e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffa85e9"]])

export default __exports__